import { render, staticRenderFns } from "./returnGoods.vue?vue&type=template&id=cf9d880a&scoped=true&"
import script from "./returnGoods.vue?vue&type=script&lang=js&"
export * from "./returnGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9d880a",
  null
  
)

export default component.exports